import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import UniversityForm from './UniversityForm';
import Header from '../../../components/marketplace/Header';
// import ResearchQuestions from './ResearchQuestions';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UniversityProfile = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);

  // Fetch teacher profile
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        const data = await res.json();
        if (res.ok) setProfile(data.data);
        else console.error('Profile fetch failed', data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingProfile(false);
      }
    };
    fetchProfile();
  }, []);



  if (loadingProfile) return (
    <div className="teacher-profile-page">
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading profile...</p>
      </div>
    </div>
  );

  if (!profile) return (
    <div className="teacher-profile-page">
      <div className="error-container">
        <p>No profile found</p>
      </div>
    </div>
  );

  return (

   <>
   <Header/>
   <div className="min-h-screen bg-gray-50 font-[Inter,-apple-system,BlinkMacSystemFont,sans-serif]">
    <div className="max-w-6xl mx-auto pt-8 px-4 pb-16">
      {/* Cover Image */}
      <div 
        className="relative w-full h-72 rounded-2xl overflow-hidden"
        style={{ 
          backgroundImage: `url(${profile.cover_image || "https://tse1.mm.bing.net/th/id/OIP.ndX6aNjihdve_vBMnQkhZwHaB-?pid=Api&P=0&h=220"})` 
        }}
      >
        <div className="absolute bottom-0 left-0 right-0 h-2/3 bg-gradient-to-t from-black/20 to-transparent rounded-b-2xl"></div>
      </div>
  
      {/* Profile Header */}
      <div className="flex items-end gap-6 -mt-20 px-4 relative z-10">
        {/* Profile Picture */}
        <div className="relative">
          <img
            src={profile.profile_picture}
            alt="Profile"
            className="w-40 h-40 rounded-2xl border-4 border-white object-cover shadow-lg"
          />
          <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-green-500 rounded-full border-2 border-white"></div>
        </div>
  
        {/* Profile Info */}
        <div className="flex-1 pb-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-1.5 h-6 bg-[#0f6abf] rounded-full"></div>
            <h1 className="text-2xl font-bold text-gray-900">
              {profile.name}
            </h1>
          </div>
          
          <div className="flex items-center gap-2 mb-1">
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <p className="text-lg font-semibold text-gray-700">
              {profile.current_activity || "Educator & Mentor"}
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <p className="text-base font-medium text-gray-600">
              {profile.institution || "Axionnest University"}
            </p>
          </div>
        </div>
      </div>
  
      {/* Info Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-8 px-4">
        {/* About Section */}
        <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-900">About</h2>
          </div>
          <p className="text-gray-700 leading-relaxed">
            {profile.bio || "Passionate educator dedicated to sharing knowledge and inspiring students."}
          </p>
        </div>
  
        {/* Education Section */}
        <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-900">Education / Degree</h2>
          </div>
          <div className="space-y-2">
            <p className="text-gray-700">{profile.degree || "Master's in Education"}</p>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <span>Primary Affiliation: {profile.primary_affiliation || "Axionnest Education"}</span>
            </div>
          </div>
        </div>
  
        {/* Research Areas Section */}
        <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-900">Research Areas</h2>
          </div>
          <p className="text-gray-700 leading-relaxed">
            {profile.research_areas || "Educational Technology, Curriculum Development, Student Engagement"}
          </p>
        </div>
      </div>
  
      {/* CTA Section */}
      <div className="bg-white p-8 rounded-2xl border border-gray-200 my-8 mx-4">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
            <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              Complete Your University Profile
            </h2>
            <p className="text-gray-600 mt-1">
              Fill Necessary Information to Registered Your University
            </p>
          </div>
        </div>
        <p className="text-gray-600 leading-relaxed">
          Completing these details will help people understand your expertise and find you easily.
        </p>
      </div>
  
      <UniversityForm/>
    </div>
  </div>
   </>
  );
};

export default UniversityProfile;
